<template>
  <span class="payment-brand-logo" aria-hidden="true">
    <svg v-if="channel === &quot;wechat&quot;" data-payment-brand="wechat" viewBox="0 0 36 36" focusable="false">
      <rect width="36" height="36" rx="10" fill="#07c160" />
      <path fill="#fff" d="M15.2 8.2c-5.1 0-9.2 3.3-9.2 7.5 0 2.4 1.4 4.6 3.7 6l-.8 2.8 3.3-1.7c1 .3 2 .5 3 .5h.6a8 8 0 0 1-.3-2.1c0-4.2 3.7-7.6 8.5-7.9-1.2-3-4.6-5.1-8.8-5.1Zm-3.4 5.2c-.8 0-1.4-.6-1.4-1.3s.6-1.3 1.4-1.3 1.4.6 1.4 1.3-.6 1.3-1.4 1.3Zm6.6 0c-.8 0-1.4-.6-1.4-1.3s.6-1.3 1.4-1.3 1.4.6 1.4 1.3-.6 1.3-1.4 1.3Z" />
      <path fill="#fff" d="M30.2 21.1c0-3.7-3.5-6.7-7.7-6.7s-7.7 3-7.7 6.7 3.5 6.7 7.7 6.7c.9 0 1.8-.2 2.7-.4l2.8 1.5-.7-2.5c1.8-1.3 2.9-3.2 2.9-5.3Zm-10.3-1.5c-.7 0-1.2-.5-1.2-1.1 0-.6.5-1.1 1.2-1.1s1.2.5 1.2 1.1c0 .6-.5 1.1-1.2 1.1Zm5.5 0c-.7 0-1.2-.5-1.2-1.1 0-.6.5-1.1 1.2-1.1s1.2.5 1.2 1.1c0 .6-.5 1.1-1.2 1.1Z" />
    </svg>

    <svg v-else-if="channel === &quot;alipay&quot;" data-payment-brand="alipay" viewBox="0 0 36 36" focusable="false">
      <rect width="36" height="36" rx="10" fill="#1677ff" />
      <path d="M10 10.5h16M18 6.8v7.1M11.5 15.2h13c-1.5 4.2-5.5 8.2-12.7 11.2" fill="none" stroke="#fff" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.5 18.1c4.4 4.8 9.2 7.6 15.8 9.4" fill="none" stroke="#fff" stroke-width="2.7" stroke-linecap="round" />
      <path d="M6.4 27.4c7.5-4.2 14.5-4.1 23.2-.8" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" />
    </svg>

    <svg v-else-if="channel === &quot;paypal&quot;" data-payment-brand="paypal" viewBox="0 0 36 36" focusable="false">
      <rect width="36" height="36" rx="10" fill="#fff" />
      <path fill="#003087" d="M10.2 6.5h9.2c4.9 0 7.5 2.5 6.7 6.8-1 5.1-4.5 7.3-9.3 7.3h-2.4l-1.7 8.9H7.9l2.3-23Zm5.1 4-1.2 6.3h2.6c2.5 0 4.1-1.1 4.5-3.3.4-2-.8-3-3-3h-2.9Z" />
      <path fill="#009cde" d="M15.8 13.6h7.6c4.1 0 6.2 2.1 5.5 5.7-.8 4.3-3.8 6.1-7.8 6.1h-2l-1.3 6.1h-4l3.1-15.4h2.5c-.7-1.5-2-2.3-3.6-2.5Zm4 3.2-1 5.3H21c2.1 0 3.4-.9 3.8-2.8.3-1.7-.7-2.5-2.6-2.5h-2.4Z" opacity=".9" />
    </svg>

    <svg v-else data-payment-brand="generic" viewBox="0 0 36 36" focusable="false">
      <rect width="36" height="36" rx="10" fill="#f3f4f7" />
      <rect x="6.5" y="10" width="23" height="16" rx="3" fill="none" stroke="#555b68" stroke-width="2.2" />
      <path d="M7.5 15.5h21M11 21.5h5" fill="none" stroke="#555b68" stroke-width="2.2" stroke-linecap="round" />
    </svg>
  </span>
</template>

<script>
export default {
  name: "PaymentBrandLogo",
  props: {
    channel: { type: String, default: "" }
  }
}
</script>

<style scoped>
.payment-brand-logo{width:32px;height:32px;display:inline-grid;place-items:center;flex:none;overflow:hidden;border:1px solid rgba(255,255,255,.13);border-radius:10px;background:#fff;box-shadow:0 5px 15px rgba(0,0,0,.2)}
.payment-brand-logo svg{width:100%;height:100%;display:block}
</style>
